import React, { useEffect, useMemo } from 'react';
import CustomSelect from '../../components/CustomSelect';
import { gameTypeMap, gameTypeOptions } from '../../constants/gameType';
import {
  useGetCustomSelectButtonElement,
  useSetSelectDefaultValue,
} from '../../hooks/init';
import { SingleCommonType } from '../../types';
import { gameTypePlaceholder } from '../../constants/placeholder';
import { commonBackInfo } from '../../utils';
import useLanguage from '@/pages/opinion/hooks/useLanguage';
import { NO_DATE } from '@/pages/opinion/constants';
import { FilterButtonPoint } from '@op/operationLog/pages/filter';

export default function GameTypeSelect({
  onChange,
  defaultValue,
  filterValue,
  defaultKey,
  lang,
  oriDefaultFilter,
  backOriDefaultValue,
}: SingleCommonType) {
  const {
    selects: gameTypeSelects,
    setSelects: setGameTypeSelects,
    diffClassName,
  } = useSetSelectDefaultValue<string>({
    defaultValue,
    filterValue,
    oriDefaultFilter,
    backOriDefaultValue,
    defaultKey: 'game_type',
    options: gameTypeOptions.map((item) => item.value),
  });

  const { formatOptionsMessage, formatMessage } = useLanguage();

  const { customSelectRef, getButtonElement } =
    useGetCustomSelectButtonElement();

  useEffect(() => {
    const [text, isAll] = getButtonElement();
    onChange?.(
      'game_type',
      commonBackInfo(
        { game_type: gameTypeSelects },
        { [defaultKey]: text },
        { isAll, needChangeEntity: true },
      ),
    );
  }, [gameTypeSelects]);

  const gameTypeValue = useMemo(() => {
    return gameTypeSelects.map(String);
  }, [gameTypeSelects]);

  return (
    <div className={`game-type-select-wrapper ${diffClassName}`}>
      <CustomSelect
        ref={customSelectRef}
        placeholderText={gameTypePlaceholder[lang]}
        onClear={() => setGameTypeSelects([])}
        buttonItemRender={(item: string) =>
          formatMessage({ id: gameTypeMap[item] || NO_DATE.EMPTY })
        }
        selectOptionsInfo={[gameTypeValue, setGameTypeSelects]}
        options={formatOptionsMessage(gameTypeOptions)}
        pointKey={FilterButtonPoint.gameType}
      ></CustomSelect>
    </div>
  );
}
